<template>
  <div id="homeView">
    <div class="searchBar">
      <a-input-search
        size="large"
        allow-clear
        v-model="formSearchParams.appName"
        :style="{ width: '320px' }"
        placeholder="发现答题应用"
        search-button
        @change="doSearch"
      />
    </div>

    <a-list
      :grid-props="{ gutter: [20, 20], sm: 24, md: 12, lg: 8, xl: 6 }"
      class="list-demo-action-layout"
      :bordered="false"
      :data="dataList"
      :pagination-props="{
        pageSize: searchParams.pageSize,
        current: searchParams.current,
        total,
      }"
      @page-change="onPageChange"
    >
      <template #item="{ item }">
        <AppCard :app="item" />
      </template>
    </a-list>
  </div>
</template>

<script setup lang="ts">
import { listAppVoByPageUsingPost } from "@/api/appController";
import AppCard from "@/components/AppCard.vue";
import { ref, watchEffect } from "vue";
import API from "@/api";
import message from "@arco-design/web-vue/es/message";
import { REVIEW_STATUS_ENUM } from "@/constant/app";

const formSearchParams = ref<API.AppQueryRequest>({});
// 初始化搜索条件（不被修改）
const initSearchParams = {
  current: 1,
  pageSize: 12,
};

const searchParams = ref<API.AppQueryRequest>({
  ...initSearchParams,
});

const dataList = ref<API.AppVO[]>([]);
const total = ref<number>(0);

// 加载数据
const loadData = async () => {
  const params = {
    reviewStatus: REVIEW_STATUS_ENUM.PASS, // 只展示审核通过的应用
    ...searchParams.value,
  };
  const res = await listAppVoByPageUsingPost(params);
  if (res.data.code === 0) {
    dataList.value = res.data.data?.records || [];
    total.value = res.data.data?.total || 0;
  } else {
    message.error("获取数据失败，" + res.data.message);
  }
};

/**
 * 当页数变化时，改变搜索条件，为后续触发加载
 */
const onPageChange = (page: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: page,
  };
};

/**
 * 监听 searchParams 变量：触发加载
 */
watchEffect(() => {
  loadData();
});

/**
 * 执行搜索
 */
const doSearch = () => {
  searchParams.value = {
    ...initSearchParams,
    ...formSearchParams.value,
  };
};
</script>

<style scoped>
#homeView {
  display: static;
}

.searchBar {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}

.list-demo-action-layout .image-area {
  width: 183px;
  height: 119px;
  border-radius: 2px;
  overflow: hidden;
}

.list-demo-action-layout .list-demo-item {
  padding: 20px 0;
  border-bottom: 1px solid var(--color-fill-3);
}

.list-demo-action-layout .image-area img {
  width: 100%;
}

.list-demo-action-layout .arco-list-item-action .arco-icon {
  margin: 0 4px;
}
</style>
